import RequireAuth from "./requireAuth";
import Loading from "./global components/Loading";
import NotFound from "./global components/NotFound/NotFound";
import AdminLogin from "./pages/AdminRoute/Authentication/Login";
import AdminForgotPassword from "./pages/AdminRoute/Authentication/Forgot Password";
import AdminResetCode from "./pages/AdminRoute/Authentication/ResetCode";
import AdminResetPassword from "./pages/AdminRoute/Authentication/Reset Password";
import AdminViewDetails from "./pages/AdminRoute/Dashboard/Message/Local Components/ViewDetails";
import AdminMessageDetails from "./pages/AdminRoute/Dashboard/Message/Local Components/ViewDetails/Message Details";

import PromoInnerPage from "./pages/AdminRoute/Dashboard/PromoCode/Local Components/InnerPage";
import CreateCode from "./pages/AdminRoute/Dashboard/PromoCode/Local Components/CreateCode";
import ViewDetails from "./pages/AdminRoute/Dashboard/Users/Local component/ViewDetails";
import UserDetails from "./pages/AdminRoute/Dashboard/Users/Local component/ViewDetails/UserDetails";
import MessageDetails from "./pages/AdminRoute/Dashboard/Users/Local component/ViewDetails/Message Details";
import PendingVerificationWrapper from "./pages/AdminRoute/Dashboard/NumberManagement/PendingVerificationWrapper";

import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorFallBack from "./global components/ErrorFallBack";
import ScrollToTop from "./global components/ScrollToTop";
import APIManagementWrapper from "./pages/AdminRoute/Dashboard/APIManagement/APIManagementWrapper";
import SendMessage from "./pages/AdminRoute/Dashboard/Users/SendMessage";
import Users from "./pages/AdminRoute/Dashboard/Users";
import SendMessageWrapper from "./pages/AdminRoute/Dashboard/Users/SendMessage/SendMessageWrapper";
import NumberManagement from "./pages/AdminRoute/Dashboard/NumberManagement";
import Overview from "./pages/AdminRoute/Dashboard/Overview";
import Reports from "./pages/AdminRoute/Dashboard/Reports";
import Transactions from "./pages/AdminRoute/Dashboard/Transactions";
import Subscribers from "./pages/AdminRoute/Dashboard/Subscribers";
import PendingRequests from "./pages/AdminRoute/Dashboard/NumberManagement/PendingVerificationWrapper/PendingRequests";
import Team from "./pages/AdminRoute/Dashboard/Team";
import APIManagement from "./pages/AdminRoute/Dashboard/APIManagement";
import Requests from "./pages/AdminRoute/Dashboard/APIManagement/APIManagementWrapper/Requests";
import AdminAccount from "./pages/AdminRoute/Dashboard/Account";
import PromoCode from "./pages/AdminRoute/Dashboard/PromoCode";
import AdminMessage from "./pages/AdminRoute/Dashboard/Message";
import UserAdminMessageDetails from "./pages/AdminRoute/Dashboard/Users/SendMessage/SendMessageWrapper/Message Details";

import APIRanking from "./pages/AdminRoute/Dashboard/APIManagement/APIManagementWrapper/Ranking";
import APIRankingDetails from "./pages/AdminRoute/Dashboard/APIManagement/APIManagementWrapper/Ranking/ActivityDetails";
import APIUsers from "./pages/AdminRoute/Dashboard/APIManagement/APIManagementWrapper/User";
import APIUsersDetails from "./pages/AdminRoute/Dashboard/APIManagement/APIManagementWrapper/User/ViewDetails";

const AdminPortal = lazy(() => import("./pages/AdminRoute/Dashboard"));
const Authentication = lazy(
  () => import("./pages/AdminRoute/Authentication/Index"),
);

export const router = createBrowserRouter([
  { path: "*", element: <NotFound /> },
  { path: "/", element: <Navigate to="/auth" replace /> },
  {
    path: "auth",
    element: <Suspense fallback={<Loading />} children={<Authentication />} />,
    errorElement: <ErrorFallBack />,

    children: [
      { index: true, element: <AdminLogin /> },
      { path: "signin", element: <AdminLogin /> },
      { path: "forgot-password", element: <AdminForgotPassword /> },
      { path: "change-password", element: <AdminForgotPassword /> },
      { path: "resetcode", element: <AdminResetCode /> },
      { path: "reset-password", element: <AdminResetPassword /> },
    ],
  },

  {
    element: (
      <>
        <ScrollToTop />
        <RequireAuth />
      </>
    ),
    errorElement: <ErrorFallBack />,

    children: [
      {
        path: "dashboard",
        element: <Suspense fallback={<Loading />} children={<AdminPortal />} />,
        children: [
          {
            index: true,
            element: <Overview />,
          },
          {
            path: "overview",
            element: <Overview />,
          },
          {
            path: "transactions",
            element: <Transactions />,
          },
          {
            path: "subscribers",
            element: <Subscribers />,
          },
          {
            path: "promo-code",
            element: <PromoCode />,
          },
          {
            path: "promo-code/create",
            element: <PromoInnerPage />,
            children: [
              { index: true, element: <CreateCode /> },
              { path: "edit", element: <CreateCode /> },
            ],
          },
          {
            path: "Message",
            element: <AdminMessage />,
          },
          {
            path: "Message/message-details",
            element: <AdminViewDetails />,
            children: [{ index: true, element: <AdminMessageDetails /> }],
          },
          {
            path: "Team",
            element: <Team />,
          },
          {
            path: "users",
            element: <Users />,
          },
          {
            path: "users/profile",
            element: <ViewDetails />,
            children: [
              { index: true, element: <UserDetails /> },
              { path: "users/profile", element: <UserDetails /> },
              { path: "message-details", element: <MessageDetails /> },
            ],
          },
          {
            path: "users/send-message",
            element: <SendMessage />,
            children: [
              {
                index: true,
                element: <SendMessageWrapper />,
              },
              {
                path: "details/:msgId",
                element: <UserAdminMessageDetails />,
              },
            ],
          },
          {
            path: "reports",
            element: <Reports />,
          },
          {
            path: "number-management",
            element: <NumberManagement />,
          },
          {
            path: "number-management/pending-requests",
            element: <PendingVerificationWrapper />,
            children: [
              {
                index: true,
                element: <PendingRequests />,
              },
            ],
          },
          {
            path: "api-management",
            element: <APIManagement />,
          },
          {
            path: "api-management/requests",
            element: <APIManagementWrapper />,
            children: [
              {
                index: true,
                element: <Requests />,
              },
              {
                path: "users",
                element: (
                  <Suspense fallback={<Loading />} children={<APIUsers />} />
                ),
              },
              {
                path: "ranking",
                element: <APIRanking />,
              },
              {
                path: "ranking/activity-details/:id",
                element: <APIRankingDetails />,
              },
              {
                path: "user/view-details/:id",
                element: <APIUsersDetails />,
              },
            ],
          },
          {
            path: "settings",
            element: <AdminAccount />,
          },
        ],
      },
    ],
  },
]);
